module.exports = __webpack_public_path__ + "img/top-illustration.34ad26fc.svg";